const content = {
  component: "PageTypeA",
  cssClass: "page-four",
  meta: {
    title: "العنوان: شركة National Instruments تزدهر بفضل التكنولوجيا السحابية",
    description:
      "انتقلت شركة National Instruments إلى منصة سحابية للموارد البشرية، مما ساعدها على تطوير الموظفين وتحقيق معدلات مرتفعة من النمو.",
    og: {
      type: "website",
      title: "التكنولوجيا السحابية تعزز كفاءة الموظفين - اعرف المزيد",
      description: `أرادت الشركة تركيز أداء الموظفين على المجالات التي تشهد معدلات مرتفعة من النمو. ولأنها شركة دولية تضم فروعًا في عدة دول، كان توزيع الموظفين على المهام الملائمة لهم تحديًا كبيرًا. لكن باستخدام التكنولوجيا السحابية، استطاعت الشركة نقل نُظم إدارة الموظفين لمنصة موحدة، مما أكسب المدراء رؤية شاملة للمهارات والموظفين والتخصصات.`,
      image: require("../../assets/images/social/high-growth-culture-1200x630.jpg")
    },
    twitter: {
      card: "summary",
      title:
        "اعرف كيف عززت التكنولوجيا السحابية من أداء موظفي National Instruments",
      description: `وضعت شركة National Instruments منظومة عمل تركّز على المجالات مرتفعة النمو. وبفضل التكنولوجيا السحابية المبتكرة، استطاعت وضع الموظف المناسب في المكان المناسب.`,
      site: "@Oracle",
      creator: "@Oracle",
      image: require("../../assets/images/social/high-growth-culture-300x300.jpg")
    }
  },
  title:
    "<span>العنوان: شركة National Instruments تزدهر بفضل التكنولوجيا السحابية</span>",
  heroImage: {
    preload: require("../../assets/images/bgs/high-growth-culture-pre.jpg"),
    loaded: require("../../assets/images/bgs/high-growth-culture.jpg"),
    mobile: require("../../assets/images/bgs/high-growth-culture-mobile.jpg")
  },
  // * the heroImageOptions are currently only required and supported when using the PageTypeA component
  heroImageOptions: {
    default: {
      customPosition: [false]
    },
    mobile: {
      customPosition: [false]
    },
    limtedHeight: {
      customPosition: [false]
    }
  },
  sections: [
    {
      component: "SectionCopy",
      content: {
        copy: `
        نجحت شركة National Instruments في تغيير الطريقة التي تدير بها موظفيها الموهوبين للتأكد من تركيز كل منهم على أولويات النمو الحالية في فروع الشركة حول العالم.
        `,
        type: "intro"
      }
    },
    {
      component: "SectionSeperator",
      content: {
        image: null
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
        <p>تصنع شركة National Instruments، ومقرها في أوستن بولاية تكساس الأمريكية، معداتٍ متخصصة متعددة الوحدات وبرامج لتصميم النُظم لاستخدام المهندسين. وقد نجحت الشركة، تحت قيادة أليكس دافيرن - الذي أصبح في يناير عام 2017 الرئيس التنفيذي خلفًا لمؤسس الشركة جيمس تروشارد ـ- في تركيز مهارات موظفيها على المجالات التي تشهد نموًا بمعدلات مرتفعة، وتشمل اختبارات أشباه الموصلات، والجيل الخامس للأنظمة اللاسلكية، والمَركبات المتصلة معًا بالربط الشبكي، وتقنية إنترنت الأشياء الصناعية.</p>
        <p>وفي إطار هذه المساعي، نجح فريق الموارد البشرية في الشركة في تصميم عملية جديدة لإدارة أداء الموظفين؛ حيث تَمكَّن من بناء نظام أساسي جديد للموارد البشرية يستند إلى التكنولوجيا السحابية. ومن الميزات الرئيسية في هذا النظام الأساسي ميزة "التحديد التعاقبي للأهداف"، التي تساعد مدراء الموارد البشرية ومدراء الأقسام في الشركة على معرفة نوع العمل أو المهمة التي يقوم بها الموظفون حاليًا، وتتبع أدائهم، وربط تقييم أجور كل موظف بحجم إنجازه. تقول كيت بريسكوت نائبة رئيس الموارد البشرية الدولية في الشركة: "لقد ساعدنا ذلك على إنشاء ثقافة تكافئ الموظفين بقدر أدائهم وإنجازاتهم في العمل."</p>
        `,
        type: "default"
      }
    },
    {
      component: "SectionQuote",
      content: {
        quote: ` وتضيف قائلة: "في مستوى معين، سعدنا برؤية فروعنا في كل بلد تبادر بتطبيق هذا النظام لرصد أداء الموظفين. ورغم ذلك، كان أحد التحديات الكبيرة التي واجهتنا القدرة على إدارة معايير متسقة ومتماثلة، وتحقيق استفادة عملية من النتائج. كنا بحاجة إلى نظام جديد قادر على مساعدتنا ليس فقط في الحصول على المزيد من البيانات، بل أيضًا في استخلاص النتائج والاستنباطات والدلالات من هذه البيانات.`,
        author: `Cate Prescott`,
        position: `Vice President of Global Human Resources, National Instruments`,
        type: "quote",
        backgroundImage: require("../../assets/images/bgs/HighGrowthCulture_NationalInstruments_bg.jpg")
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
          <p>قامت National Instruments أولاً بتقييم نقاط القوة والضعف في موظفي كل قسم موقع دولة. ولأن بيانات كل الموظفين صارت متوفرة الآن عبر التكنولوجيا السحابية، أصبح بمقدور مدراء الموارد البشرية ومدراء الأقسام على سبيل المثال معرفة أنواع البرامج التي يعمل عليها المهندسون في ألمانيا أو الهند أو الصين، والتأكد من مكافأتهم بكل شفافية أو تكليفهم بمشاريع تحظى بأولوية أعلى. </p>
          <p>تقول "ويندي كوتريل"، مديرة أنظمة معلومات الموارد البشرية في الشركة: "لم يُتح لنا من قبل معرفة هذه التفاصيل عن الموظفين بهذا القدر من الشفافية. وأحد أسباب ذلك، أن أقسام الموارد البشرية في الفروع الإقليمية لم يكن لديها القدرة على الرصد بهذا المستوى الشامل. ولم يكن لدينا أي فكرة عن مهارات موظفينا المنتشرين في أنحاء العالم."</p>
          <p>اكتسب هذا المنظور العالمي أهميته بشكل خاص مع تطوُّر شركة National Instruments من منهج المبيعات المعتمدة على المنتجات إلى استراتيجية يمثّل العملاء محورها ونقطة تركيزها.</p>
        `,
        type: "default"
      }
    },
    {
      component: "SectionImage",
      content: {
        image: require("../../assets/images/content/HighGrowthCulture_InlineImage.jpg"),
        alt: "",
        type: "image"
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
          <p>في السابق، كان موظفو المبيعات والتسويق في الشركة يركزون فقط على تلبية الطلب على منتجات بعينها. يقول جايسون جرين، نائب الرئيس للمبيعات والتسويق في الأميركتين: "إن وضع استراتيجية جديدة كان يعني تحديد التوقعات الجديدة عن كيفية قيامنا بشراكة مع العملاء للتغلب على تحديات أكثر تعقيدًا على مستوى النظام. كما كنا بحاجة أيضًا إلى تحفيز الموظفين عبر تطوير أدوار جديدة بتوقعات جديدة وطريقة جديدة للبيع تتطلب الإتقان التام للوظيفة المنوطة بكل واحد."</p>
          <p>والآن يوثق "جرين" هذه التوقعات بالمهارات والكفاءات المطلوبة لكل دور؛ ونتج عن ذلك تطوير عملية مراجعة أداء موظفي كل فريق تتكون من تسع نقاط، وترصد هذه النقاط إمكانات كل موظف وقدراته ومهاراته وتضع الخطط اللازمة لتعاقب الموظفين بشكل ناجح. </p>
          <p>يُكمل جرين حديثه قائلاً: "نحن الآن قادرون على التواصل المستمر مع الموظفين على أساس توقعات واضحة، ونستطيع رصد أدائهم، وتطوير قدراتهم باستمرار طوال العام. وما كنّا لنتمكن من إجراء هذه التغييرات، وما كانت الشركة لتحقق هذا النمو والتوسع من دون الأدوات التي توفرها منصة Oracle HCM Cloud."</p>
        `,
        type: "default"
      }
    },
    {
      component: "SectionCallToAction",
      content: {
        title: `طوّر أعمالك مع حلول وتكنولوجيا Oracle`,
        ctas: [
          {
            image: require("../../assets/images/svgs/report.svg"),
            copy: `تقرير "صُنّاع القرار والتكنولوجيا"`,
            url:
              "https://www.oracle.com/sa-ar/applications/human-capital-management/driving-hr-innovation.html?source=:ow:o:cs:mt:RC_EMMK181024P00070C0004:YTTFY19_HR_AW_HI_CM_SA_C33_Q33_RT&intcmp=:ow:o:cs:mt:RC_EMMK181024P00070C0004:YTTFY19_HR_AW_HI_CM_SA_C33_Q33_RT",
            buttonCopy: "اقرأ التقرير"
          },
          {
            image: require("../../assets/images/svgs/servers.svg"),
            copy: "جرِّب حلول Oracle Cloud السحابية",
            url:
              "https://go.oracle.com/LP=43623?qt=saas_hcm_hr_SimplifytheHumanResourcesExperiencewithaGlobalHRSolution&src1=:ow:o:cs:mt:RC_EMMK181024P00070C0004:YTTFY19_HR_CT_QT_CM_SA_C38_Q34&intcmp=WWMK161025P00095:ow:o:cs:mt:RC_EMMK181024P00070C0004:YTTFY19_HR_CT_QT_CM_SA_C38_Q34",
            buttonCopy: "‫جرِّبها الآن‬"
          }
        ],
        type: "cta"
      }
    }
  ]
};

export default content;
